import React from 'react';
import makeLazyLoadingWrapper from 'app/components/mixins/makeLazyLoadingWrapper';
import Spinner from 'app/components/svgs/Spinner';
import { GREY_Q } from 'app/constants/Colors';
import { useI18n } from 'app/components/localization';
import ReloadButton from 'app/components/common/ReloadButton';
import { useClasses } from 'app/utils/css';

const containerStyle = {
  flexGrow: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

const wrapComponent = makeLazyLoadingWrapper({
  LoadingComponent: () => {
    const classes = useClasses({
      containerStyle,
      spinner: {
        maxHeight: '50px',
        maxWidth: '50px',
      },
    });
    return (
      <span className={classes.containerStyle}>
        <span className={classes.spinner}>
          <Spinner color={GREY_Q} />
        </span>
      </span>
    );
  },

  ErrorComponent: ({ retryLoad }) => {
    const classes = useClasses({
      containerStyle,
      reload: {
        overflow: 'auto',
      },
      loadingError: {
        marginRight: '5px',
      },
    });

    const { t } = useI18n();

    return (
      <span className={classes.containerStyle}>
        <span className={classes.reload}>
          <span className={classes.loadingError}>
            {t('lazy-loading-component.loading-error')}
          </span>

          <ReloadButton onClick={retryLoad}>
            {t('lazy-loading-component.retry-button-label')}
          </ReloadButton>
        </span>
      </span>
    );
  },
});


export default <T extends React.ComponentType<any>>(
  getModule: () => Promise<{ default: T }>,
) => wrapComponent(
  async () => (await getModule()).default,
);
